import { render, staticRenderFns } from "./cuttingStyle.vue?vue&type=template&id=6f6e54b2&"
import script from "./cuttingStyle.vue?vue&type=script&lang=js&"
export * from "./cuttingStyle.vue?vue&type=script&lang=js&"
import style0 from "./cuttingStyle.vue?vue&type=style&index=0&id=6f6e54b2&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports